import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function NeurologicalDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Neurological Conditions Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please provide the exact diagnosis:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosis.referToAttachments}>
                        <p>{questions.diagnosis.subQuestions.exactDiagnosis}</p>

                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosis.subQuestions.dateOfDiagnosis)}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please provide details of any symptoms to include:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.symptoms.referToAttachments}>
                        <br />
                        <Question>Frequency:</Question>
                        <p>{questions.symptoms.subQuestions.frequency}</p>

                        <Question>Severity:</Question>
                        <p>{questions.symptoms.subQuestions.severity}</p>

                        <Question>Date of last symptoms:</Question>
                        <p>{formatDateMonthYear(questions.symptoms.subQuestions.dateOfLastSymptoms)}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide the date and result of any investigations in the last 5 years:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <OutputDetails
                            details={questions.investigations.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Please provide details of any treatment and the response to the that treatment:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentDetails.referToAttachments}>
                        <p>{questions.treatmentDetails.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Has your patient always been compliant with recommended treatments and follow-ups?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.isAlwaysCompliant.referToAttachments}>
                        <p>{questions.isAlwaysCompliant.value}</p>

                        {questions.isAlwaysCompliant.value === 'No' && (
                            <>
                                <Question>If no, please provide dates and details:</Question>
                                <p>{questions.isAlwaysCompliant.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Is there any history of hospitalisation?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.hospitalisations.referToAttachments}>
                        <p>{questions.hospitalisations.value}</p>
                        {questions.hospitalisations.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details and dates</Question>
                                <OutputDetails
                                    details={questions.hospitalisations.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Has the Patient had any ongoing restrictions/limitations or time off work?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.ongoingRestrictions.referToAttachments}>
                        <p>{questions.ongoingRestrictions.value}</p>
                        {questions.ongoingRestrictions.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details including date(s) & duration:</Question>
                                <OutputDetails
                                    details={questions.ongoingRestrictions.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='8'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}